















































































































import { ApplicationConfirmation } from './ApplicationConfirmation'
export default ApplicationConfirmation
